import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styling/App.css";
import "@fontsource/inter/variable-full.css";
import {BrowserRouter} from "react-router-dom";
import {AuthMessages} from "serpotrack-frontend-authentication";
import {IntlProvider} from "react-intl";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    // <React.StrictMode>
    <IntlProvider
        locale="en-US"
        messages={AuthMessages}
    >
        <BrowserRouter>
            <App/>
        </BrowserRouter>
    </IntlProvider>
    // </React.StrictMode>
);